const DurationString = (seconds: number) => {
    if ( seconds < 60 ) {
        return `${Math.floor(seconds)}s`;
    }else {
        return `${Math.floor(seconds / 60)}m ${Math.floor(seconds % 60)}s`;
    }
}

export default DurationString;